// extracted by mini-css-extract-plugin
module.exports = {"subnav-wrap":"mC","subnavWrap":"mC","subnav-menu-header":"mD","subnavMenuHeader":"mD","subnav-menu-li":"mE","subnavMenuLi":"mE"};